import { ButtonMain, Loader } from '@quero-delivery/quero-components-web';

import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';

import styles from './PlaceDetails.module.scss';

import { BankDetails } from '@/Components/place/bank-details/bank-deatils';
import JsonView from '@/Shared/JsonView';
import Balance from '@/Components/Balance/Balance';
import PlaceInfo from '@/Components/place/place-info/PlaceInfo';
import PurpleButton from '@/Components/shared/purple-button/PurpleButton';
import FareType from '@/Components/place/fare-type/FareType';
import FaresApplied from '@/Components/place/fares-applied/FaresApplied';
import { AccessPermission } from '@/_components/access-permission';
import { useAppDispatch } from '@/_store/hooks';
import { setPlaceSelectedToEdit } from '@/_store/modules/places';
import { useGetPlaceById } from '@/_features/places/api/get-place-by-id';
import { ToggleGroup } from '@/_features/places/components/toggle-group/toggle-group';
import useScreenType from '@/hooks/util/useScreenType';

function PlaceDetails() {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const { placeId } = useParams<{ placeId: string }>();
  const isMobile = useScreenType('tablet');

  const {
    data: place,
    isLoading,
    error,
  } = useGetPlaceById({
    placeId: placeId || '',
  });

  if (error) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const errorsData = (error as any).response?.data?.errors;
    return (
      <div className="container">
        <div className="header-container">
          <div className="back-label" onClick={() => navigate(-1)}>
            <FontAwesomeIcon icon={faChevronLeft} size="lg" />
            <strong>Voltar</strong>
          </div>
        </div>

        <div>
          {errorsData
            ? errorsData.map((err: string) => (
                <p key={err} className="mgn-sm" role="alert">
                  <b>Erro:</b> {err}
                </p>
              ))
            : 'Erro ao carregar informações do estabelecimento.'}
        </div>
      </div>
    );
  }

  function handleOpenFareForm() {
    navigate('tarifa');
  }

  if (isLoading || !place) {
    return (
      <div className="loading-container">
        <Loader />
      </div>
    );
  }

  return (
    <div className="container">
      <div className="header-container">
        <div className="back-label" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faChevronLeft} size="lg" />
          <strong>Voltar</strong>
        </div>
        <div className={styles.headerActions}>
          {!isMobile && <FareType place={place} />}
          <AccessPermission permissionKey="place.createAndEditFlare">
            <PurpleButton onClick={handleOpenFareForm}>
              <span className="font-medium" style={{ whiteSpace: 'nowrap' }}>
                {place.placeFare ? 'Alterar' : 'Criar'} tarifa
              </span>
            </PurpleButton>
          </AccessPermission>
          <AccessPermission permissionKey="place.editPlace">
            <ButtonMain
              secondary
              textFirst="editar"
              textEnd="estabelecimento"
              onClick={() => {
                dispatch(setPlaceSelectedToEdit(place));
                navigate(`editar`);
              }}
            />
          </AccessPermission>
        </div>
      </div>

      <div className={styles.placeDetailsTitle}>
        <h2>
          <b> {place.nomeExibicao}</b>
        </h2>

        <Balance placeId={placeId} />
      </div>

      {isMobile && <ToggleGroup />}

      {isMobile && <FareType place={place} />}

      <div className={styles.containerPlaceInfo}>
        <div className={styles.sideContainer}>
          <div className={styles.bankContainer}>
            <h4>
              <b>Bank</b>
            </h4>
            <BankDetails placeId={place._id} />
          </div>
        </div>

        <div className={styles.sideContainer}>
          {!isMobile && <ToggleGroup />}
          <PlaceInfo place={place} />

          <FaresApplied place={place} />
        </div>
      </div>

      <JsonView name="Place" source={place} />
    </div>
  );
}

export default PlaceDetails;
